// @flow
import React from "react";
import styled from "styled-components";

//https://github.com/styled-components/styled-components/issues/1349

const color = props => {
  if (props.positive) return props.theme.color.positive;
  if (props.negative) return props.theme.color.negative;
  if (props.white) return `#fff;`;
  if (props.light) return `#6B8096;`;
  if (props.grey) return `#aaa;`;
  if (props.theme && props.theme.color && props.theme.color.text)
    return props.theme.color.text;
  else return "black";
};

const Text = styled.div`
  font-family: ${props => (props.lato ? "Lato" : props.theme.font.default)},
    sans-serif;
  color: ${props => color};
  font-weight: 400;
  /* letter-spacing: -1px; */
  line-height: 1.2em;
  margin: 0;
  font-size: ${props => (props.size ? props.size : 1)}rem;
  ${props => props.center && "text-align: center;"};
  ${props => props.left && "text-align: left;"};
  ${props => props.right && "text-align: right;"};
  ${props => props.bold && "font-weight: 700;"};
  ${props => props.bolder && "font-weight: 900;"};
  ${props => props.nowrap && "white-space: nowrap;"};
  ${props => props.uppercase && "text-transform: uppercase;"};
  ${props => props.shadow && "text-shadow: 1px 1px 2px #333"};
  ${props => props.spacing && `margin-top: ${props.spacing}rem`};
  ${props =>
    props.clip &&
    `white-space: nowrap;overflow: hidden;text-overflow: ellipsis;`};
`;
Text.span = Text.withComponent("span");
Text.h1 = Text.withComponent("h1");
Text.h2 = Text.withComponent("h2");
Text.h3 = Text.withComponent("h3");
Text.h4 = Text.withComponent("h4");
Text.h4 = Text.withComponent("h4");

export default Text;
